export const DEFAULT_MOBILE_IMAGE_SIZE = 350;
export const DEFAULT_IMAGE_SIZE = 500;

export const IMAGE_SIZES = {
  'marketplace-for-clairvoyant-services': 541,
  fernwayer: {
    default: 478,
    secondSectionView: 650,
  },
  fireaway: {
    default: 425,
  },
  dindon: {
    default: 440,
  },
  'seven-pm-thursday': {
    default: 478,
  },
  stickerbox: {
    default: 480,
  },
  fairy: {
    default: 478,
  },
  'open-sense': {
    default: 440,
  },
  'drive-focus': {
    default: 440,
  },
  tell: {
    default: 478,
  },
  'travel-trivia': {
    default: 478,
  },
  'cash-chat': {
    default: 478,
  },
  beautonomy: 600,
  meateater: {
    default: 470,
  },
  'separate-us': {
    default: 440,
  },
  'fintech-app-for-credit-score': {
    default: 480,
  },
  ubichat: {
    default: 500,
  },
  telemojo: {
    default: 440,
  },
  famlicious: 478,
  bionorica: {
    default: 500,
  },
  humankind: {
    default: 515,
  },
  blackbird: {
    default: 480,
  },
  'software-for-mri-interpretation': 630,
  'fusion-markets': {
    default: 440,
  },
  'machine-learning-in-real-estate': {
    sixthSectionView: 480,
  },
  'mobile-bank-application': {
    default: 586,
  },
  'forex-trading-platform': {
    default: 560,
  },
  'kitchen-equipment-customizer': {
    default: 622,
  },
  'mobile-music-app': {
    firstSectionView: 600,
    secondSectionView: 100,
  },
  'medical-software-for-musculoskeletal-rehabilitation': {
    default: 600,
  },
  'ai-software-development-services': {
    firstSectionView: 208,
  },
  'ai-documentation-processing': {
    firstSectionView: 522,
  },
};

export const MOBILE_IMAGE_SIZES = {
  fireaway: {
    default: 250,
  },
  tell: {
    default: 350,
  },
  'separate-us': {
    default: 180,
  },
  'drive-focus': {
    default: 220,
  },
  ubichat: {
    default: 220,
  },
  'marketplace-for-clairvoyant-services': {
    default: 206,
  },
  'fusion-markets': {
    default: 206,
  },
  telemojo: {
    default: 206,
  },
  blackbird: {
    default: 350,
  },
  dindon: {
    default: 181,
  },
  humankind: {
    default: 181,
  },
  'machine-learning-in-real-estate': {
    sixthSectionView: 240,
  },
  'mobile-bank-application': {
    default: 550,
  },
  'forex-trading-platform': {
    default: 228,
  },
  meateater: {
    default: 211,
  },
  'kitchen-equipment-customizer': {
    default: 206,
  },
  'mobile-music-app': {
    firstSectionView: 600,
    secondSectionView: 40,
  },
  'medical-software-for-musculoskeletal-rehabilitation': {
    default: 320,
  },
  'ai-software-development-services': {
    firstSectionView: 188,
  },
  'ai-documentation-processing': {
    firstSectionView: 206,
  },
};
